import { useTranslation } from 'react-i18next';

const Strengths = () => {
  const { t } = useTranslation();

  const strengths = [
    {
      icon: 'ri-earth-line',
      title: t('strength_1_title'),
      desc: t('strength_1_desc'),
    },
    {
      icon: 'ri-stack-line',
      title: t('strength_2_title'),
      desc: t('strength_2_desc'),
    },
    {
      icon: 'ri-exchange-line',
      title: t('strength_3_title'),
      desc: t('strength_3_desc'),
    },
    {
      icon: 'ri-shield-star-line',
      title: t('strength_4_title'),
      desc: t('strength_4_desc'),
    },
    {
      icon: 'ri-service-line',
      title: t('strength_5_title'),
      desc: t('strength_5_desc'),
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28" aria-labelledby="strengths-heading">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
            <p className="text-gold-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
              {t('strengths_label')}
            </p>
            <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
          </div>
          <h2 id="strengths-heading" className="text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-navy-900 leading-tight">
            {t('strengths_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {strengths.map((item) => (
            <div
              key={item.title}
              className="bg-navy-50 rounded-sm p-6 md:p-8 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-white border border-gold-200/60 group-hover:border-gold-400 transition-colors duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl text-gold-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-navy-900 mb-3">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strengths;
